export const calculateComputedStyles = (name: string) => {
    const boxSizes = document.getElementById(name) as Element | null

    if (boxSizes) {
        const computedStyle = window.getComputedStyle(boxSizes)

        const paddingLeft = parseFloat(computedStyle.paddingLeft)
        const paddingRight = parseFloat(computedStyle.paddingRight)
        const totalHorizontalPadding = paddingLeft + paddingRight

        const marginLeft = parseFloat(computedStyle.marginLeft)
        const marginRight = parseFloat(computedStyle.marginRight)
        const totalHorizontalMargin = marginLeft + marginRight

        const totalInlineOffset = totalHorizontalMargin + totalHorizontalPadding

        return totalInlineOffset
    }
}
